(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('result-report', {
            parent: 'entity',
            url: '/result-report',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.resultReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/result-report/result-reports.html',
                    controller: 'ResultReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resultReport');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('result-report-detail', {
            parent: 'entity',
            url: '/result-report/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.resultReport.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/result-report/result-report-detail.html',
                    controller: 'ResultReportDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('resultReport');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ResultReport', function($stateParams, ResultReport) {
                    return ResultReport.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('result-report.new', {
            parent: 'result-report',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-report/result-report-dialog.html',
                    controller: 'ResultReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                reportText: null,
                                reportPdf: null,
                                reportPdfContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('result-report', null, { reload: true });
                }, function() {
                    $state.go('result-report');
                });
            }]
        })
        .state('result-report.edit', {
            parent: 'result-report',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-report/result-report-dialog.html',
                    controller: 'ResultReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ResultReport', function(ResultReport) {
                            return ResultReport.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('result-report', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('result-report.delete', {
            parent: 'result-report',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-report/result-report-delete-dialog.html',
                    controller: 'ResultReportDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ResultReport', function(ResultReport) {
                            return ResultReport.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('result-report', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
